import { useEffect, useRef } from 'react';

/*
 * after a row write: the dialog hands focus back to its opener, but the re-read that lands a
 * moment later can unmount that opener (Waive becomes Undo waiver, a removed row goes).
 */
const focus_lost = (el) => !el || el === document.body || el.getAttribute('role') === 'dialog';

// The row renders twice (table and phone card); only the visible copy can take focus.
const focus_first = (candidates) =>
  candidates.some((el) => {
    el.focus({ preventScroll: true });
    return document.activeElement === el;
  });

export const useRowRefocus = (scope_ref, heading_ref, rows) => {
  const opened = useRef(null);
  const armed = useRef(null);

  const remember = (uuid) => {
    opened.current = { uuid, opener: document.activeElement };
  };
  const arm = () => {
    armed.current = opened.current;
  };

  useEffect(() => {
    const a = armed.current;
    if (!a) return;
    armed.current = null;
    if (a.opener && a.opener.isConnected) return;
    // Focus the operator already moved somewhere real is left alone.
    if (!focus_lost(document.activeElement)) return;
    const scope = scope_ref.current;
    const actions =
      scope && a.uuid
        ? [...scope.querySelectorAll(`[data-actions-for="${a.uuid}"] button`)].filter(
            (b) => b.parentElement.firstElementChild === b
          )
        : [];
    if (focus_first(actions)) return;
    if (heading_ref.current) heading_ref.current.focus({ preventScroll: true });
  }, [rows, scope_ref, heading_ref]);

  return { remember, arm };
};
